/**
 * Mission-level validation: interim agency, service and address fields.
 *
 * Splits out of the old monolithic `validate` function that used to live inside
 * `workers-request-form.tsx`. Exposes a pure function with an explicit input/output
 * shape so it can be unit-tested in isolation.
 */
import {
  WorkersRequestCreateUpdateFormValues,
  WorkersRequestFormErrors,
} from '../workers-request-form.types'

/**
 * Validates top-level mission fields (interim agency, service, address).
 *
 * @param values - Current Formik values.
 * @returns Partial errors object keyed the same way as the Formik errors tree.
 */
export const validateMissionData = (
  values: WorkersRequestCreateUpdateFormValues,
): WorkersRequestFormErrors => {
  const errors: WorkersRequestFormErrors = {}

  // Interim agency selection is always mandatory.
  if (!values.interimAgency) errors['interimAgency'] = 'Champ requis'

  // Service (affectation) is required when creating or editing the mission.
  if (!values.missionData?.service) {
    if (!errors.missionData) errors.missionData = {}
    errors.missionData.service = 'Champ requis'
  }

  // Address is required for the mission.
  if (!values.missionData?.address) {
    if (!errors.missionData) errors.missionData = {}
    errors.missionData.address = 'Champ requis'
  }

  return errors
}
